<template>
    <nav
        class="navbar navbar-marketing navbar-expand-lg bg-transparent navbar-dark fixed-top"
    >
        <div class="container">
            <img
                class="img-logo"
                :src="app.caminho_logomarca"
                :alt="app.nome"
            />
            <a class="navbar-brand text-white" href=""> </a>
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <i data-feather="menu"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto mr-5">
                    <li class="nav-item">
                        <a class="nav-link" href="">
                            Home
                        </a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link" href="#beneficios">
                            Benefícios
                        </a>
                    </li>
                    <!-- <li class="nav-item ">
                                        <a class="nav-link " href="#atendimento">
                                            Atendimento
                                        </a>
                                    </li> -->
                    <li class="nav-item ">
                        <a class="nav-link" href="#abrir-empresa">
                            Abrir empresa
                        </a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link" href="#trocar-contador">
                            Trocar contador
                        </a>
                    </li>
                </ul>
                <a class="btn-teal btn rounded-pill px-4 ml-lg-4" href="/login">
                    Área do cliente
                    <i class="fas fa-arrow-down ml-1"></i>
                </a>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    props: ['app']
}
</script>
